import { c as _c } from "react/compiler-runtime";
import { TablePagination as KuramaTablePagination } from '@precis-digital/kurama/Table';
import type { ReactElement, RefObject } from 'react';
import type { ChartDataRow } from '../../types';
import type { ChartCardTable } from './tanstack';
import type { CompleteTablePaginationState } from './types';
interface TablePaginationProps<DataKey extends string, DataRow extends ChartDataRow<DataKey>> {
  tableRef: RefObject<ChartCardTable<DataKey, DataRow> | null>;
  completePaginationState: CompleteTablePaginationState | null;
}
const TablePagination = t0 => {
  const $ = _c(10);
  const {
    tableRef,
    completePaginationState
  } = t0;
  if (completePaginationState == null) {
    return null;
  }
  const table = tableRef.current;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = (_, page) => {
      table?.setPageIndex(page);
    };
    t2 = [10, 20, 30, 40, 50];
    t3 = e => {
      table?.setPageSize(Number(e.target.value));
    };
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== completePaginationState.pageIndex || $[4] !== completePaginationState.pageSize || $[5] !== completePaginationState.rowsCount || $[6] !== completePaginationState.totalRowsCount || $[7] !== t1 || $[8] !== t3) {
    t4 = <KuramaTablePagination count={completePaginationState.rowsCount} totalCount={completePaginationState.totalRowsCount} page={completePaginationState.pageIndex} rowsPerPage={completePaginationState.pageSize} onPageChange={t1} rowsPerPageOptions={t2} onRowsPerPageChange={t3} shouldShowPageNumber={true} inScrollingContainer={true} />;
    $[3] = completePaginationState.pageIndex;
    $[4] = completePaginationState.pageSize;
    $[5] = completePaginationState.rowsCount;
    $[6] = completePaginationState.totalRowsCount;
    $[7] = t1;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export default TablePagination;